import type { Logo3DInstance } from './utils/logo3d';

// Entry loaded by index.html right after the static loading screen. It swaps the empty
// [data-logo3d-slot] placeholders (the loading screen's logo, and BootSpinner's) for the real WebGL 3D
// logo as soon as three.js has loaded. If WebGL isn't available it falls back to the flat logo.
const FALLBACK_SRC = '/logo.png?v=20260331b';

// three.js is loaded on demand (its own chunk, fetched in parallel with the app) so it never bloats the main bundle.
const loadLogo3D = () => import('./utils/logo3d');

async function mountSlot(slot: HTMLElement) {
  if (slot.getAttribute('data-mounted')) return;
  slot.setAttribute('data-mounted', '1');
  const size = slot.getBoundingClientRect().width || 140;
  try {
    const { createLogo3D } = await loadLogo3D();
    const inst = createLogo3D(size, { shine: true, swing: 0.4 });
    (slot as any).__logo3d = inst as Logo3DInstance;
    slot.appendChild(inst.canvas);
    inst.show();
  } catch {
    const img = document.createElement('img');
    img.src = FALLBACK_SRC;
    img.alt = '';
    img.style.cssText = 'width:100%;height:100%;object-fit:contain';
    slot.appendChild(img);
  }
}

// Start fetching three.js straight away, even before a slot needs it.
loadLogo3D().catch(() => undefined);

export function mountBootLogos() {
  document.querySelectorAll<HTMLElement>('[data-logo3d-slot]').forEach(mountSlot);
}

(window as any).__mountBootLogo = mountBootLogos;
mountBootLogos();
